import { observable, action, computed } from 'mobx';

import { AppManager } from 'core/index';
import InboxAppManager from 'apps/Inbox/appManager';
import { routerStore } from 'core/routing';

const routesWithMakeButton = [
  'profile.shared.file',
  'initiative.shared.file',
  'workspace.make-part.file',
  'profile.project.file',
  'initiative.project.file',
  'profile.project.version.file',
  'initiative.project.version.file',
];
class FrameStore extends AppManager {
  static registryName = 'FrameStore';

  @observable inboxManager = null;

  @observable file = null;
  @observable quote = null;
  @observable contextManager = null;
  @observable sharedFileManager = null;
  @observable project = null;
  @observable viewType = '';
  @observable projectSortInfo = null;
  @observable currentUsers = [];

  @action initialize = () => {
    this.inboxManager = new InboxAppManager(this);
  };

  @action SetFile = file => {
    this.file = file;
  };

  @action SetQuote = quote => {
    this.quote = quote;
  };

  @action SetContextManager = contextManager => {
    this.contextManager = contextManager;
  };

  getUserInfoById = userId => {
    return this.currentUsers?.find(profile => profile?.user?.id === userId);
  };

  @action SetCurrentUsers = currentUsers => {
    this.currentUsers = currentUsers;
  };

  @action SetSharedFileManager = sharedFileManager => {
    this.sharedFileManager = sharedFileManager;
  };

  @action SetProjectSortInfo = projectSortInfo => {
    this.projectSortInfo = projectSortInfo;
  };

  @action SetProject = project => {
    this.project = project;
  };

  @action SetViewType = type => {
    this.viewType = type;
  };

  @computed get isRouteWithMakeButton() {
    return routesWithMakeButton.includes(routerStore.route.name);
  }

  @computed get isRouteWithInfoButton() {
    return (
      (routerStore.route.name.includes('order') &&
        !routerStore.route.name.includes('orders')) ||
      (routerStore.route.name.includes('rfq') &&
        !routerStore.route.name.includes('rfqs'))
    );
  }

  @computed get canShowDiffPanel() {
    return routerStore.route.params.panel === 'diff';
  }

  @computed get canShowMakePanel() {
    if (this.isRouteWithMakeButton) {
      return routerStore.route.params.panel === 'rfq';
    }

    return false;
  }

  @computed get canShowInfoPanel() {
    if (this.isRouteWithInfoButton) {
      return routerStore.route.params.panel === 'info';
    }
    return false;
  }

  @computed get canShowRightPanel() {
    return this.canShowMakePanel || this.canShowInfoPanel;
  }
}

export const frameStore = new FrameStore(null, {}, { autoDispose: false });
